import { useState, useEffect } from "react";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import { getCustomers } from "../../../api/customers";
import { getSpecies } from "../../../api/species";
import { getPlaceById } from "../../../api/places";
import { getReportData } from "../../../api/reports";
import { formatDateForQuery } from "../../../utils/formatDate";
import "../Styles.css";
import { Oval } from "react-loader-spinner";
import { generateXls } from "./excel";
const TechnicalVisits = (props) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [species, setSpecies] = useState([]);
  const [places, setPlaces] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState(null);
  const [selectedSpecies, setSelectedSpecies] = useState(null);
  const [selectedPlaces, setSelectedPlaces] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);

  const loadCustomers = async () => {
    try {
      const { data } = await getCustomers();
      setCustomers(data);
    } catch (error) {
      console.error("Error al obtener clientes:", error);
    }
  };

  const loadSpecies = async () => {
    try {
      const { data } = await getSpecies();
      setSpecies(data);
    } catch (error) {
      console.error("Error al obtener especies:", error);
    }
  };

  const loadPlaces = () => {
    const places = [];

    selectedCustomers.map(async (customer) => {
      try {
        const { data } = await getPlaceById(customer.id);
        places.push(...data);
      } catch (error) {
        console.error("Error al obtener lugares:", error);
      }
    });
    setPlaces(places);
  };

  useEffect(() => {
    if (selectedCustomers) loadPlaces();
    // eslint-disable-next-line
  }, [selectedCustomers]);

  useEffect(() => {
    loadCustomers();
    loadSpecies();
  }, []);

  const fieldsValidation = () => {
    if (
      !startDate ||
      !endDate ||
      !selectedCustomers ||
      !selectedPlaces ||
      !selectedSpecies
    ) {
      props.showToast("error", "Error", "Debe completar todos los campos");
      return false;
    }
    return true;
  };

  const onSearch = async () => {
    const isValid = fieldsValidation();
    if (!isValid) return;
    setIsDownloading(true);
    const places = selectedPlaces.map((place) => place.id);
    const species = selectedSpecies.map((specie) => specie.id);
    const formattedStartDate = formatDateForQuery(new Date(startDate));
    const formattedEndDate = formatDateForQuery(new Date(endDate));
    const payload = {
      name: "Visitas técnicas realizadas",
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      places,
      species,
    };
    try {
      const { data } = await getReportData(payload);
      console.log("Reporte obtenido:", data);
      setIsDownloading(false);
      generateXls(data);
    } catch (err) {
      setIsDownloading(false);
      console.error("Error al obtener reporte:", err);
      props.showToast("error", "Error", "Error al obtener reporte");
    }
  };

  return (
    <div>
      <div className="row">
        <div className="p-inputgroup" style={{ marginRight: 10 }}>
          <span className="dateLabel">Desde:</span>
          <Calendar
            id="startDate"
            placeholder="Desde"
            value={startDate}
            onChange={(e) => setStartDate(e.value)}
            dateFormat="dd/mm/yy"
          />
        </div>
        <div className="p-inputgroup" style={{ marginRight: 10 }}>
          <span className="dateLabel">Hasta:</span>
          <Calendar
            id="endDate"
            placeholder="Hasta"
            value={endDate}
            onChange={(e) => setEndDate(e.value)}
            dateFormat="dd/mm/yy"
          />
        </div>
      </div>
      <div className="row">
        <div className="p-inputgroup" style={{ marginRight: 10 }}>
          <span className="dateLabel">Cliente:</span>
          <MultiSelect
            value={selectedCustomers}
            onChange={(e) => setSelectedCustomers(e.value)}
            options={customers}
            optionLabel="name"
            placeholder="Seleccione Clientes"
            maxSelectedLabels={1}
          />
        </div>
        <div className="p-inputgroup" style={{ marginRight: 10 }}>
          <span className="dateLabel">Lugares:</span>
          <MultiSelect
            value={selectedPlaces}
            onChange={(e) => setSelectedPlaces(e.value)}
            options={places}
            optionLabel="name"
            placeholder="Seleccione Lugares"
            maxSelectedLabels={1}
          />
        </div>
      </div>
      <div className="row">
        <div className="p-inputgroup" style={{ marginRight: 10 }}>
          <span className="dateLabel">Especies:</span>
          <MultiSelect
            value={selectedSpecies}
            onChange={(e) => setSelectedSpecies(e.value)}
            options={species}
            optionLabel="name"
            placeholder="Seleccione Especies"
            maxSelectedLabels={1}
          />
        </div>
      </div>
      <div className="p-inputgroup">
        {isDownloading ? (
          <div style={{ padding: 10 }}>
            <Oval visible={true} height="40" width="40" color="#0078d4" />
          </div>
        ) : (
          <Button label="Exportar" icon="pi pi-file-excel" onClick={onSearch} />
        )}
      </div>
    </div>
  );
};

export default TechnicalVisits;
